module.exports = __webpack_public_path__ + "img/skridsko.4d666e3e.jpg";